export default class BannerVideoComponent {
    constructor() {
        BannerVideoComponent.init()
    }

    static init() {
        const videoElmt = document.createElement('video')
        const videoSrc = document.createElement('source')

        videoSrc.type = $('[data-banner-video]').data('banner-video-type')
        videoSrc.src = $('[data-banner-video]').data('banner-video-src')
        videoElmt.muted = true
        videoElmt.loop = true

        videoElmt.appendChild(videoSrc)
        $('[data-banner-video]').append(videoElmt)
        videoElmt.play()
    }
}
